import type { SVGProps } from 'react';

const SvgChevronArrowDownBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M20 8L12 16L4 8' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgChevronArrowDownBd;
